<template>
  <footer>
    <div class="coyright">
      <span>GLOWICOM &copy; 2020 - <span class="uppercase">Todos los derechos reservados • All Rights Reserved</span></span>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style>
.coyright {
  background: #000;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.coyright span {
  color: #fff;
  font-weight: 500;
  text-align: center;
  font-size: 10px;
}
.uppercase {
  text-transform: uppercase;
}
</style>
